import React from 'react'

const ServiceCard = ({ serv: { iconCSSClass, title, description } }) => {
    return (
        <div className="col col-d-6 col-t-6 col-m-12 border-line-h">
            <div className="service-item">
                <div className="icon">
                    <span className={"ion " + iconCSSClass} ></span>
                </div>
                <div className="name">
                    <span >
                    {title} </span>
                </div>
                <div className="desc">
                    <div >
                        <p>{description}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ServiceCard;